import { render } from "./BatteryStatus.vue?vue&type=template&id=63908b08"
import script from "./BatteryStatus.vue?vue&type=script&lang=js"
export * from "./BatteryStatus.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lifepass-passes-app/lifepass-passes-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__